// Thin host wrapper — Post-Tournament CLV Audit. Free tier sees the
// executive summary; full leg table is gated to sika_pro
// (INTEGRATION_PATCH §7). Envelope is "wired but empty" until Pinnacle
// closes flow — the page renders that path.
import { useParams, useNavigate } from "react-router-dom";
import { useUserTier } from "../../auth/useUserTier.ts";
import { tierMeets } from "../../auth/tier-gates.ts";
import { useIntlAccaDebrief } from "../../intl-acca/useIntlAccaDebrief.ts";
import { DebriefPage } from "./DebriefPage.tsx";

export function IntlAccaDebriefRoute(): JSX.Element {
  const { tournamentId = "" } = useParams();
  const navigate = useNavigate();
  const { tierCode } = useUserTier();
  const vm = useIntlAccaDebrief(tournamentId);
  return (
    <DebriefPage
      loading={vm.loading}
      error={vm.error}
      tournament={vm.tournament}
      envelope={vm.envelope}
      canSeeFullAudit={tierMeets(tierCode, "sika_pro")}
      onUpgrade={() => navigate("/intl-acca/pass")}
    />
  );
}
